import axios from '@/controllers/request'

/**
 * ai构建对话
 */
export const aiChatToBuildAPI = async messages => {
  return await axios.post(`/api/v1/assistant/application_completion`, { messages })
}

/**
 * ai构建生成
 */
export async function textToBuildAPI(text) {
  return await axios.post('/api/v1/assistant/auto_create_assistant', { text })
}

/**
 * 创建同款应用
 */
export async function createByTemplateAPI(id) {
  return await axios.get(`/api/v1/assistant/template_info/${id}`)
}
